module.exports = __webpack_public_path__ + "static/eco_ant_bait-74649aec41abc30dd3f824e654930d18.jpg";